// extracted by mini-css-extract-plugin
module.exports = {"content":"statusColored_content__1Kqhu","color":"statusColored_color__KGztg","text":"statusColored_text__KnSKS"};